import * as React from 'react';
import { SlideUpPanel } from 'mobile-ui/components/slideup-panel';
import {
    PanelHeader,
    CloseButton,
    PanelBody,
    Preloader,
    Panel,
    Filters,
    AutoScrollbars,
    PanelFooter,
    Button
} from 'components';
import { connect } from 'react-redux';
import { IState } from 'services/root-reducer';

import { actions as appActions } from 'services/app/app-service';
import { actions as containersActions } from 'services/containers/containers-service';

import {
    CONTAINER_CODE,
    CONTAINER_ID
} from 'scenes/map/controls/object-filters-window';
import { getOperation, getOperationData } from 'selectors';
import { IOperation, EOperationStatus } from 'types';
import { InfrastructureFilter } from 'scenes/map/controls/object-filters-window/tab-general/infrastructure-filter';

import './style.scss';
import { routes } from 'routes';
import { WithTranslation, withTranslation } from 'react-i18next';
import { romanToArabic, romanToArabSortAsc } from 'utils/sort/roman-number-converter';

export interface IMobileUIObjectFiltersWindowProps extends WithTranslation {
    filters: IState[ 'operations' ][ 'FILTERS' ];
    filtersWindowVisible: IState[ 'app' ][ 'filtersWindowVisible' ];
    containersOperation: IOperation;
}
export interface IMobileUIObjectFiltersWindowState {

}

export const mapStateToProps = (state: IState) => ({
    filters: getOperation(state, 'FILTERS'),
    filtersWindowVisible: state.app.filtersWindowVisible,
    containersOperation: getOperation(state, 'CONTAINERS')
});

const MOBILE_AREA_FILTER_ID = 22;
const MOBILE_SPB_DISTANCE_FILTER_ID = 45;
const MOBILE_ALLOWED_USAGE_TYPE_FILTER_ID = 26;
const MOBILE_DANGER_CLASS_FILTER_ID = 46;
const MOBILE_POWERS_FILTER_ID = 58;
const MOBILE_GAS_FILTER_ID = 67;
const MOBILE_WATER_SUPPLY = 68;
const MOBILE_SEWERAGE = 69;


/* eslint-disable @typescript-eslint/indent */
class MobileUIObjectFiltersWindowComponent extends React.Component<
    IMobileUIObjectFiltersWindowProps,
    IMobileUIObjectFiltersWindowState
> {
/* eslint-enable @typescript-eslint/indent */

    constructor(props: IMobileUIObjectFiltersWindowProps) {
        super(props);
    }

    onFilterChange(filter_id: number, filter_value: any, debounced = false) {
        if (!debounced) {
            containersActions.setFilter({
                code: CONTAINER_CODE,
                id: filter_id,
                value: filter_value
            });
        } else {
            containersActions.setFilterDebounced({
                code: CONTAINER_CODE,
                id: filter_id,
                value: filter_value
            });
        }
    }

    calcObjectCount() {
        let { containersOperation } = this.props;
        let containers: any[] = containersOperation.data;

        let childs = containers.filter(c => c.parent_id === CONTAINER_ID);

        return childs.reduce((amount, c) => amount + c.objectsCount, 0);
    }

    private renderFilterComponentById<T extends React.FC>(
        filter_id: number,
        rest_props: Partial<React.ComponentProps<T>> = {}
    ) {
        let filters = this.props.filters.data[CONTAINER_CODE];
        let filter = filters.find(f => f.id === filter_id);
        if (!filter) return null;
        // let FilterComponent = Filters[filter.type];
        let FilterComponent = filter.id === MOBILE_AREA_FILTER_ID ? Filters['log_range'] : Filters[filter.type];
        return (
            <FilterComponent
                filter={filter}
                {...rest_props}
            />
        );
    }

    renderBody() {
        let { status } = this.props.filters;
        let { t } = this.props;

        if (status !== EOperationStatus.SUCCESS) {
            return (
                <PanelBody>
                    <Preloader />
                </PanelBody>
            );
        } else {
            return (
                <PanelBody>
                    <AutoScrollbars>
                        <div className="scroll-fix">
                            {this.renderFilterComponentById<typeof Filters['list_text']>(
                                MOBILE_DANGER_CLASS_FILTER_ID,
                                {
                                    onFilterChange: this.onFilterChange,
                                    sortListItems: romanToArabSortAsc
                                }
                            )}
                            {this.renderFilterComponentById<typeof Filters['range']>(
                                MOBILE_AREA_FILTER_ID,
                                { onFilterChange: this.onFilterChange }
                            )}
                            {this.renderFilterComponentById<typeof Filters['powers']>(
                                MOBILE_POWERS_FILTER_ID,
                                { onFilterChange: this.onFilterChange, steps: [ 1, 3, 6 ] }
                            )}
                            {this.renderFilterComponentById<typeof Filters['gas']>(
                                MOBILE_GAS_FILTER_ID,
                                { onFilterChange: this.onFilterChange, steps: [ 2, 5, 10 ], minValue: 0 }
                            )}
                            {this.renderFilterComponentById<typeof Filters['list_text']>(
                                MOBILE_ALLOWED_USAGE_TYPE_FILTER_ID,
                                { onFilterChange: this.onFilterChange }
                            )}
                            {this.renderFilterComponentById<typeof Filters['range']>(
                                MOBILE_SPB_DISTANCE_FILTER_ID,
                                { onFilterChange: this.onFilterChange }
                            )}
                            {this.renderFilterComponentById<typeof Filters['water_supply']>(
                                MOBILE_WATER_SUPPLY,
                                { onFilterChange: this.onFilterChange }
                            )}
                            {this.renderFilterComponentById<typeof Filters['sewerage']>(
                                MOBILE_SEWERAGE,
                                { onFilterChange: this.onFilterChange }
                            )}
                            <div className="mobile-ui-infrastructure-wrapper">
                                {/* <div className="infrastructure-title">
                                    {t('Инфраструктура')}
                                </div> */}

                                <InfrastructureFilter
                                    title={t('Наличие инфраструктуры')}
                                    filters={this.props.filters.data[CONTAINER_CODE]}
                                    HAS_WATER_FILTER_ID={47}
                                    HAS_DRAINAGE_FILTER_ID={48}
                                    HAS_ELECTRICITY_FILTER_ID={49}
                                    HAS_OIL_FILTER_ID={50}
                                    HAS_HEAT_FILTER_ID={51}
                                    onFilterChage={(new_filter) => {
                                        containersActions.setFilter({
                                            code: CONTAINER_CODE,
                                            id: new_filter.id,
                                            value: new_filter.value
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </AutoScrollbars>
                </PanelBody>
            );
        }
    }

    renderFooter() {
        return (
            <PanelFooter>
                <Button
                    text={this.props.t('Показать список')}
                    onClick={() => {
                        appActions.hideObjectFiltersWindow();
                        routes.redirect(routes.list, {
                            layerCode: CONTAINER_CODE
                        });
                    }}
                />
                <Button
                    outlined
                    text={this.props.t('Сбросить фильтр')}
                    onClick={() => {
                        containersActions.clearFiltersByLayerCode(CONTAINER_CODE);
                    }}
                />
            </PanelFooter>
        );
    }

    render() {
        let { filtersWindowVisible } = this.props;

        if (!filtersWindowVisible) {
            return null;
        }

        return (
            <SlideUpPanel
                open={this.props.filtersWindowVisible}
                className='mobile-ui-object-filters-window fix-close-button'
            >
                <PanelHeader>
                    <div className="fixed-spacer">
                        {/*
                            По дизайну тут должна быть кнопка назад, но ее тут нет,
                            но ее наличие учитывается в стилях, поэтому нужно вставить такую пустую
                            болванку с размерами кнопки
                        */}
                    </div>
                    <div className="objects-found">
                        <div className="label">{this.props.t('Выбрано')}</div>
                        <div className="objects-amount">{this.calcObjectCount()}</div>
                    </div>
                    <CloseButton
                        onClick={() => {
                            appActions.hideObjectFiltersWindow();
                        }}
                    />
                </PanelHeader>

                { this.renderBody() }
                { this.renderFooter() }
            </SlideUpPanel>
        );
    }
}

export const MobileUIObjectFiltersWindow = withTranslation()(
    connect(mapStateToProps)(
        MobileUIObjectFiltersWindowComponent
    )
);
